import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useEffect } from "react";
import * as Styled from "./style";

export type LoadingProps = {
  /** ローディングアイコンの大きさ */
  size: number;
  /** overlay表示フラグ */
  hasOverlay?: boolean;
};

/**
 * 共通して利用するローディングアイコン（ui-libraryで実装したので組み込み次第、削除予定）
 * @param props {@link LoadingProps}
 */
export const Loading = (props: LoadingProps) => {
  const { size, hasOverlay } = props;

  /** Loading iconが表示中, スクロールとスワイプ移動を無効化する*/
  const disableScrollAndTouchMove = () => {
    const body = document.body;
    if (!body || !hasOverlay) return;

    body.style.overflowY = "hidden";
    const disableEvent = (e: TouchEvent | WheelEvent) => {
      e.preventDefault();
    };

    body.addEventListener("touchmove", disableEvent, { passive: false });
    body.addEventListener("wheel", disableEvent, { passive: false });

    return () => {
      body.style.overflowY = "";
      body.removeEventListener("touchmove", disableEvent);
      body.removeEventListener("wheel", disableEvent);
    };
  };

  useEffect(disableScrollAndTouchMove, []);

  return (
    <>
      {!hasOverlay ? (
        <Styled.DivLoadingWrapper size={size}>
          <Icon name="loading" />
        </Styled.DivLoadingWrapper>
      ) : (
        <Styled.DivContainer>
          <Styled.DivLoadingWrapper size={size}>
            <Icon name="loading" />
          </Styled.DivLoadingWrapper>
        </Styled.DivContainer>
      )}
    </>
  );
};
